import { PartialFeatureFlags } from "../../central-atoms/feature-flags/types";
import { apiClient } from "../apiClient";

export default class FeatureFlagRequestService {
    static async fetchFeatureFlags(params: { org_id: string }): Promise<{data: PartialFeatureFlags}> {
        const response = await apiClient.post(`/get_user_feature_flags`, params);
        return response.data;
    }
}
